export const hotKeywords = [
  "雨夜直播断线",
  "剧组合约罗生门",
  "新歌抄袭疑云",
  "情侣博主要分手",
  "代言争夺战",
  "旧照翻红风波",
  "综艺剪辑争议",
  "巡演临时取消",
];

export const liveStats = [
  { id: "stat-1", label: "今日跟进事件", value: "38", unit: "起", icon: "ri-live-line" },
  { id: "stat-2", label: "累计反转更新", value: "126", unit: "次", icon: "ri-arrow-left-right-line" },
  { id: "stat-3", label: "当事人公开发声", value: "54", unit: "条", icon: "ri-mic-line" },
  { id: "stat-4", label: "官方回应收录", value: "72", unit: "份", icon: "ri-government-line" },
];

export type TimelineStage = "进展" | "反转" | "发声" | "回应";

export type TimelineItem = {
  id: string;
  date: string;
  clock: string;
  stage: TimelineStage;
  title: string;
  desc: string;
  source: string;
  heat: string;
  seriesName: string;
};

export const timelineItems: TimelineItem[] = [
  {
    id: "tl-1",
    date: "09-10",
    clock: "22:14",
    stage: "反转",
    title: "「雨夜直播断线」出现关键录音，前后说法对不上",
    desc: "上午流出的完整版录音显示，双方约定的连线时间与当事人前一天的说法存在出入，原以为是单方面失联，现更像沟通失误叠加情绪失控。",
    source: "综合多方公开信息",
    heat: "128万",
    seriesName: "雨夜直播断线事件",
  },
  {
    id: "tl-2",
    date: "09-10",
    clock: "19:40",
    stage: "发声",
    title: "当事人林一诺首次正面回应，承认沟通上有疏忽",
    desc: "回应中承认当晚沟通确有疏忽，但对「耍大牌」的说法予以否认，并表示愿意公开后台调度记录自证。",
    source: "当事人个人社交账号",
    heat: "96万",
    seriesName: "雨夜直播断线事件",
  },
  {
    id: "tl-3",
    date: "09-10",
    clock: "16:05",
    stage: "回应",
    title: "综艺《夜航星》节目组发布情况说明",
    desc: "节目组说明称当晚为设备联调延后，并非临时改动流程，向观众与嘉宾致歉，并承诺后续直播增加双轨备份。",
    source: "节目组官方声明",
    heat: "74万",
    seriesName: "雨夜直播断线事件",
  },
  {
    id: "tl-4",
    date: "09-10",
    clock: "13:22",
    stage: "进展",
    title: "《剧组合约罗生门》对方律师函曝光，索赔金额成焦点",
    desc: "律师函就解约违约金金额提出主张，与剧组早前公布的口径差距明显，双方进入准备举证阶段。",
    source: "公开法律文书记录",
    heat: "61万",
    seriesName: "剧组合约罗生门",
  },
  {
    id: "tl-5",
    date: "09-10",
    clock: "10:38",
    stage: "发声",
    title: "音乐人江晚就「新歌抄袭疑云」回应：编曲为独立完成",
    desc: "江晚发布长文梳理创作时间线，表示会配合第三方曲谱比对，呼吁外界不要在结论出来前先行定性。",
    source: "当事人长文",
    heat: "58万",
    seriesName: "新歌抄袭疑云",
  },
  {
    id: "tl-6",
    date: "09-10",
    clock: "08:15",
    stage: "进展",
    title: "「情侣博主要分手」双方账号同步停更，引发猜测",
    desc: "两人主账号在同一时段停止更新内容，但共同运营的店铺仍在正常发货，暂无法判断是分开经营还是单纯休整。",
    source: "账号动态观察",
    heat: "43万",
    seriesName: "情侣博主要分手",
  },
  {
    id: "tl-7",
    date: "09-09",
    clock: "23:47",
    stage: "反转",
    title: "「旧照翻红风波」早期配文被找出，语境与原传播版本不同",
    desc: "有网友翻出更早的原始帖子配文，显示图片原本用于公益宣传场景，与后来被解读的含义存在明显差异。",
    source: "网友整理时间线",
    heat: "39万",
    seriesName: "旧照翻红风波",
  },
  {
    id: "tl-8",
    date: "09-09",
    clock: "20:02",
    stage: "回应",
    title: "品牌方就「代言争夺战」调整官宣节奏",
    desc: "品牌方未直接回应人选争议，但宣布将原定官宣时间后移，并强调合作以公开流程为准。",
    source: "品牌官方渠道",
    heat: "35万",
    seriesName: "代言争夺战",
  },
];

export type SeriesItem = {
  id: string;
  title: string;
  episodes: number;
  status: "持续更新" | "接近尾声" | "已定档结局";
  heat: string;
  summary: string;
  tags: string[];
  cover: string;
  coverAlt: string;
};

export const seriesItems: SeriesItem[] = [
  {
    id: "series-1",
    title: "雨夜直播断线事件",
    episodes: 12,
    status: "持续更新",
    heat: "128万",
    summary:
      "一场直播临时断线，牵出沟通、流程与情绪的三重错位。从指责到录音，再到双方各自澄清，这条线几乎每更新一集就换一个方向。",
    tags: ["直播事故", "录音反转", "官方说明"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20dark%20broadcast%20studio%20with%20a%20disconnected%20cable%20and%20rain%20streaks%20on%20glass%2C%20warm%20coral%20and%20cream%20tones%2C%20dramatic%20spotlight%2C%20clean%20minimal%20graphic%20poster%20style&width=900&height=600&seq=guatian-series-01&orientation=landscape",
    coverAlt: "雨夜直播断线事件追踪封面，广播间与断线意象的插画",
  },
  {
    id: "series-2",
    title: "剧组合约罗生门",
    episodes: 9,
    status: "接近尾声",
    heat: "96万",
    summary:
      "围绕解约与违约金的拉锯，双方各执一词。合同细节、沟通记录与拍摄排期逐条被摆上台面，成为近段时间最耐看的「合约连续剧」。",
    tags: ["合约纠纷", "法律文书", "排期争议"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20an%20open%20film%20contract%20with%20a%20vintage%20director%20chair%20and%20film%20reel%2C%20warm%20coral%20and%20cream%20tones%2C%20soft%20dramatic%20lighting%2C%20clean%20minimal%20graphic%20poster%20style&width=900&height=600&seq=guatian-series-02&orientation=landscape",
    coverAlt: "剧组合约罗生门追踪封面，合约与导演椅意象的插画",
  },
  {
    id: "series-3",
    title: "新歌抄袭疑云",
    episodes: 7,
    status: "持续更新",
    heat: "74万",
    summary:
      "一首热歌被指旋律相近，随后进入曲谱比对阶段。创作者公布创作时间线，乐评人与制作人也加入讨论，专业度最高的一条线。",
    tags: ["音乐比对", "创作时间线", "第三方鉴定"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20sheet%20music%20with%20waveform%20lines%20and%20headphones%2C%20warm%20coral%20and%20cream%20tones%2C%20clean%20minimal%20graphic%20poster%20style%2C%20soft%20studio%20lighting&width=900&height=600&seq=guatian-series-03&orientation=landscape",
    coverAlt: "新歌抄袭疑云追踪封面，曲谱与波形意象的插画",
  },
  {
    id: "series-4",
    title: "情侣博主要分手",
    episodes: 5,
    status: "持续更新",
    heat: "61万",
    summary:
      "两人同步停更却仍在共同经营店铺，让「分手」与「转型」两种猜测同时存在。粉丝从细节里找线索，当事人保持沉默。",
    tags: ["账号停更", "共同经营", "粉丝竞猜"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20two%20empty%20phone%20frames%20side%20by%20side%20with%20a%20small%20package%20box%2C%20warm%20coral%20and%20cream%20tones%2C%20clean%20minimal%20graphic%20poster%20style%2C%20soft%20lighting&width=900&height=600&seq=guatian-series-04&orientation=landscape",
    coverAlt: "情侣博主要分手追踪封面，两个手机框与包裹意象的插画",
  },
  {
    id: "series-5",
    title: "代言争夺战",
    episodes: 6,
    status: "已定档结局",
    heat: "58万",
    summary:
      "同一品牌的两版官宣海报先后流出，引发粉丝比较。品牌方调整官宣节奏后，事件逐渐降温，属于节奏最快的一条线。",
    tags: ["品牌官宣", "粉丝比较", "节奏调整"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20two%20overlapping%20billboard%20posters%20with%20a%20spotlight%2C%20warm%20coral%20and%20cream%20tones%2C%20clean%20minimal%20graphic%20poster%20style&width=900&height=600&seq=guatian-series-05&orientation=landscape",
    coverAlt: "代言争夺战追踪封面，两版海报与追光意象的插画",
  },
  {
    id: "series-6",
    title: "旧照翻红风波",
    episodes: 4,
    status: "接近尾声",
    heat: "43万",
    summary:
      "一张旧照片被重新传播并赋予新含义，随后原始配文被找出，语境还原后讨论方向转变，是典型的「反转式降温」案例。",
    tags: ["旧帖还原", "语境差异", "理性讨论"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20vintage%20photo%20frame%20with%20soft%20light%20rays%20and%20dust%20particles%2C%20warm%20coral%20and%20cream%20tones%2C%20clean%20minimal%20graphic%20poster%20style&width=900&height=600&seq=guatian-series-06&orientation=landscape",
    coverAlt: "旧照翻红风波追踪封面，老照片与光线意象的插画",
  },
];

export type ReversalItem = {
  id: string;
  title: string;
  before: string;
  after: string;
  quote: string;
  quoteBy: string;
  stage: string;
};

export const reversalItems: ReversalItem[] = [
  {
    id: "rev-1",
    title: "从「单方面失联」到「双方沟通错位」",
    before: "最初流传的说法是当事人临时爽约、单方面失联，舆论几乎一边倒。",
    after: "完整录音流出后，显示两边对连线时间的理解本就不一致，属于沟通链条脱节。",
    quote: "当晚确实有衔接上的疏忽，但不该被解读成故意。",
    quoteBy: "当事人 林一诺",
    stage: "已更正",
  },
  {
    id: "rev-2",
    title: "从「抄袭实锤」到「等待曲谱比对」",
    before: "片段对比视频流传时，评论区大量使用「实锤」这样的判断性表达。",
    after: "创作者公布创作文件时间线，讨论重点转向第三方曲谱比对与专业鉴定。",
    quote: "结论出来之前，我愿意接受一切公开比对。",
    quoteBy: "音乐人 江晚",
    stage: "进行中",
  },
  {
    id: "rev-3",
    title: "从「刻意解读」到「语境还原」",
    before: "旧照被赋予新含义后，传播版本删去了原始配文与发布场景。",
    after: "原始帖子被找出，配文显示图片原本用于公益场景，讨论迅速转向反思。",
    quote: "把上下文补全，比抢第一句结论更重要。",
    quoteBy: "瓜田速报编辑部",
    stage: "已更正",
  },
];

export type OfficialItem = {
  id: string;
  org: string;
  date: string;
  title: string;
  content: string;
  effect: "降温" | "发酵中" | "已澄清";
};

export const officialItems: OfficialItem[] = [
  {
    id: "off-1",
    org: "综艺《夜航星》节目组",
    date: "09-10 16:05",
    title: "关于直播联调延后的情况说明",
    content:
      "说明指出当晚因设备联调延后调整了连线顺序，并非临时删改流程；向观众与嘉宾致歉，并表示后续直播将启用双轨备份与专人对接。",
    effect: "降温",
  },
  {
    id: "off-2",
    org: "音乐平台曲库运营方",
    date: "09-09 11:20",
    title: "关于作品比对申请的流程说明",
    content:
      "运营方表示已收到作品比对申请，将按既定流程组织专业评审，评审期间相关作品的分发策略保持不变，结论以评审结果为准。",
    effect: "发酵中",
  },
  {
    id: "off-3",
    org: "品牌方市场部",
    date: "09-09 20:02",
    title: "关于官宣节奏调整的说明",
    content:
      "品牌方说明将原定官宣时间后移，强调合作人选以公开流程为准，请外界不要依据非官方渠道流出的物料做判断。",
    effect: "已澄清",
  },
];

export type RankItem = {
  id: string;
  rank: number;
  name: string;
  heat: number;
  trend: "up" | "down" | "flat";
  category: string;
  note: string;
};

export const rankItems: RankItem[] = [
  { id: "rank-1", rank: 1, name: "雨夜直播断线事件", heat: 128, trend: "up", category: "直播事故", note: "录音更新，热度再冲高" },
  { id: "rank-2", rank: 2, name: "剧组合约罗生门", heat: 96, trend: "up", category: "合约纠纷", note: "律师函内容成讨论焦点" },
  { id: "rank-3", rank: 3, name: "新歌抄袭疑云", heat: 74, trend: "flat", category: "音乐比对", note: "等待曲谱比对结果" },
  { id: "rank-4", rank: 4, name: "情侣博主要分手", heat: 61, trend: "up", category: "账号动态", note: "店铺仍在正常经营" },
  { id: "rank-5", rank: 5, name: "代言争夺战", heat: 58, trend: "down", category: "品牌官宣", note: "官宣后移，热度回落" },
  { id: "rank-6", rank: 6, name: "旧照翻红风波", heat: 43, trend: "down", category: "旧帖还原", note: "语境还原后理性降温" },
  { id: "rank-7", rank: 7, name: "综艺剪辑争议", heat: 32, trend: "up", category: "剪辑解读", note: "正片完整版释出中" },
  { id: "rank-8", rank: 8, name: "巡演临时取消", heat: 27, trend: "flat", category: "演出变动", note: "退票通道已开启" },
];

export type FaqItem = {
  id: string;
  q: string;
  a: string;
};

export const faqItems: FaqItem[] = [
  {
    id: "faq-1",
    q: "瓜田速报多久更新一次网爆吃瓜的最新进展？",
    a: "我们采用滚动跟进的方式：出现新的后续反转、当事人发声或官方回应时，会第一时间更新到「最新进展」时间线，并在顶部标注更新时间与热度变化，让你不用反复刷新也能看到最新一集。",
  },
  {
    id: "faq-2",
    q: "网爆吃瓜后续反转一般会以什么形式呈现？",
    a: "反转会以「前后对照」的方式呈现：先写明最初的流传说法，再补充新出现的信息及其影响，并标注信息来源类型。我们尽量把每个反转的因果关系写清楚，而不是只丢一个结论。",
  },
  {
    id: "faq-3",
    q: "当事人发声和官方回应会分开记录吗？",
    a: "会。当事人发声归入「发声」标签，机构与品牌方的公开说明归入「回应」标签，时间线上可以用筛选快速切换查看。两类信息都会标注来源与时间，方便你自行判断分量。",
  },
  {
    id: "faq-4",
    q: "新瓜出现但信息零散时，你们会直接下结论吗？",
    a: "不会。信息不完整时，我们会明确标注「待补充」或「说法冲突」，并说明目前有哪些版本、各自来源是什么。我们的原则是先对齐事实，再讨论观点，避免用单一片段替代完整语境。",
  },
  {
    id: "faq-5",
    q: "我可以投稿爆料或提供线索吗？",
    a: "可以。页面底部提供爆料与联系入口，你可以留下线索类型与大致内容。需要注意的是，我们只跟进可多方核实的公开信息，涉及个人隐私、未经证实的指控类内容不会直接发布。",
  },
  {
    id: "faq-6",
    q: "站内内容会删除或更正吗？",
    a: "若后续信息证明早期叙述有误，我们会在对应条目加上「已更正」标记并说明修改原因，而不是悄悄删掉。这样既保留事件脉络，也让你能看清信息是怎样逐步清晰的。",
  },
];

export type TestimonialItem = {
  id: string;
  name: string;
  role: string;
  text: string;
};

export const testimonialItems: TestimonialItem[] = [
  {
    id: "tm-1",
    name: "夜宵多加辣",
    role: "追更两年",
    text: "最省事的就是时间线，一晚上没看手机回来，按时间倒着刷一遍就补齐了，不用在十几个帖子里翻来翻去。",
  },
  {
    id: "tm-2",
    name: "秋天的第一杯可",
    role: "地铁通勤党",
    text: "反转那块做得很舒服，一眼就能看出原来传的是什么、后来怎么改的口径，不容易被带偏。",
  },
  {
    id: "tm-3",
    name: "只看结论的猫",
    role: "内容从业者",
    text: "官方回应单独成块这点很赞，机构说明和当事人说法混在一起的时候真的很难判断，分开陈列清楚多了。",
  },
  {
    id: "tm-4",
    name: "瓜田里的稻草人",
    role: "新用户",
    text: "新瓜榜的更新挺勤的，热度变化也有标注，选题的时候直接拿来看最近大家在看什么。",
  },
];

export const contactChannels = [
  { id: "ch-1", label: "爆料与线索", value: "kefu@guatian-suhao.example.com", icon: "ri-mail-send-line" },
  { id: "ch-2", label: "内容更正申请", value: "correct@guatian-suhao.example.com", icon: "ri-edit-2-line" },
  { id: "ch-3", label: "合作与内容共建", value: "coop@guatian-suhao.example.com", icon: "ri-hand-heart-line" },
];